export const modal = {
    state: {
        modalState: {
            show: false,
            content: 'ModalEmpty',
            args: {},
            classes: null
        },
        prevStates: []
    },
    mutations: {
        TOGGLE_MODAL(state, show) {
            state.modalState.show = show
        },
        SET_CONTENT(state, content) {
            state.modalState.content = content
        },
        SET_ARGS(state, args) {
            state.modalState.args = args
        },
        SET_CLASSES(state, classes) {
            state.modalState.classes = classes
        },
        PUSH_STATE(state, pushedState) {
            state.prevStates.push(pushedState)
        },
        SHIFT_STATE(state) {
            state.prevStates.shift()
        }
    },
    actions: {
        toggleModal({ commit, dispatch }, show) {
            commit('TOGGLE_MODAL', show)
            // save to history
            if (!show) {
                dispatch('addToModalHistory', {
                    show: false,
                    content: 'ModalEmpty',
                    args: {}
                })
            }
        },
        /**
         * load modal template
         * @param {object} state  vuex state
         * @param {object} payload - mutation args
         */
        loadContent({ state, dispatch, commit }, payload) {
            commit('SET_CONTENT', 'ModalEmpty')

            // document.getElementById('baseModal').scrollTop = 0
            commit('SET_CONTENT', payload.component)
            commit('SET_ARGS', payload.args)
            commit('SET_CLASSES', payload.classes)
            // save to history
            dispatch('addToModalHistory', {
                show: state.modalState.show,
                content: payload.component,
                args: payload.args
            })
        },
        openModal({ commit, dispatch }, payload) {
            commit('TOGGLE_MODAL', true)
            dispatch('loadContent', payload)
        },
        addToModalHistory({ commit, getters }, pushedState) {
            commit('PUSH_STATE', pushedState)
            if (getters.prevStates.length > 10) {
                commit('SHIFT_STATE')
            }
        }
    },
    getters: {
        modalState: (state) => {
            return state.modalState
        },
        prevStates: (state) => {
            return state.prevStates
        }
    }
}
